import Cookies from 'js-cookie'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token : <string>Cookies.get("token"),
  },
  mutations: {
    Login(store,token:string){
      Cookies.set("token",token)
      store.token = token
    },
    LoginOut(store){
      store.token=""
      Cookies.set("token","")
    }
  },
  actions: {
    
  },
  modules: {
  }
})
